import { api } from './api';

const sessionService = {
  sendSmsToken: (msisdn: string) => api.post('/sms-token', { msisdn }),

  verifySmsToken: (msisdn: string, token: string) =>
    api.put('/sms-token', { msisdn, valor: token }),

  verifyQueryStringToken: ({
    token,
    authCode,
  }: {
    token: string;
    authCode: string;
  }) => api.post('/sessions', { token, authCode }),
};

export default sessionService;
